// @flow

import React, { Component } from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { isEmpty } from 'lodash';

import Button from 'app/common/components/Button';
import Icon from 'app/common/components/Icon';
import Modal, { ModalActions } from 'app/common/components/Modal';
import { RUN_ZAP_STATUS_ICON_MAP } from 'app/dashboard/utils/DashboardUtils';
import 'app/dashboard/components/RunZap.scss';

import type { ZapRunStatusType } from 'app/dashboard/types';

const bem = bemify('run-zap-modal');

type RunZapIncomingProps = {
  zapRunStatus: ZapRunStatusType,
  zapTitle: string,
  zapId: number,
  runZap: (zapId: number) => void,
  runZapStatus: (zapId: number) => void,
  onCloseModal: () => void,
};

type RunZapProps = {
  zapRunStatus: ZapRunStatusType,
  zapTitle: string,
  onCloseModal: () => void,
};

class RunZapStateful extends Component<RunZapIncomingProps> {
  interval: IntervalID;

  UNSAFE_componentWillMount = () => {
    const { runZap, runZapStatus, zapId } = this.props;

    runZap(zapId);
    // setup status polling
    this.interval = setInterval(() => {
      runZapStatus(zapId);
    }, 1500);
  };

  componentWillUnmount = () => {
    // teardown status polling
    clearInterval(this.interval);
  };

  render() {
    return <RunZap {...this.props} />;
  }
}

const RunZap = ({ zapRunStatus, zapTitle, onCloseModal }: RunZapProps) => (
  <Modal
    closeOnEsc={true}
    hideCloseButton={true}
    isOpened={true}
    onClose={onCloseModal}
  >
    <div>
      <div className={bem('__header')}>
        <Icon className={bem('__bolt')} type="bolt" />
        <span className={bem('__title')}>Manual Run Status</span>
      </div>
      <ul className={bem('__status-list')}>
        {zapRunStatus.map((messageObject, i) => {
          const { body, status } = messageObject;
          return (
            <li className={bem('__status-item')} key={i}>
              <Icon
                className={bem(
                  '__status-icon',
                  toModifiers({
                    [`${status && !isEmpty(status) ? status : ''}`]: true,
                  })
                )}
                type={RUN_ZAP_STATUS_ICON_MAP[status]}
              />
              <span>
                {body} {i === 0 && <strong>{zapTitle}</strong>}
              </span>
            </li>
          );
        })}
      </ul>
      <ModalActions className={bem('__modal-actions')}>
        <Button kind="primary large" onClick={onCloseModal}>
          Close
        </Button>
      </ModalActions>
    </div>
  </Modal>
);

export default RunZapStateful;
